import { render, staticRenderFns } from "./SingleReferral.vue?vue&type=template&id=01c9cfcc&scoped=true&"
import script from "./SingleReferral.vue?vue&type=script&lang=js&"
export * from "./SingleReferral.vue?vue&type=script&lang=js&"
import style0 from "./SingleReferral.vue?vue&type=style&index=0&id=01c9cfcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c9cfcc",
  null
  
)

export default component.exports